import { ApiRequestService } from "services/ApiRequestService";

export const FeedbackService = {
    submitFeedback(feedback) {
        return ApiRequestService.post("system", "Feedback", feedback);
    },
    submitIssueReport(issueReport) {
        return ApiRequestService.post("system", "IssueReports", issueReport);
    }
};
